import React from "react";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

import { ILink, IMedia } from "../../../interfaces";
import { formatPagePath } from "../../../utils";
import MediaImg from "../../media-img";

interface ICmsLink {
  link: ILink;
  classnames?: string[];
}

class CmsLink extends React.Component<ICmsLink> {
  constructor(props) {
    super(props);
  }
  render() {
    const { link, classnames = [] } = this.props;
    return <LinkBroker link={link} classnames={classnames} />;
  }
}

const LinkBroker = ({ link, classnames = [] }: ICmsLink) => {
  if (link == null) return <div></div>;
  const { page, link_text, url, new_window, thumb } = link;

  const classes = classnames.join(" ");

  if (page?.data != null) {
    return (
      <Link to={formatPagePath(page)} className={classes}>
        <InsertImage thumb={thumb} />
        {link_text}
      </Link>
    );
  } else if (url && url[0] === "#") {
    return (
      <AnchorLink to={url} gatsbyLinkProps={{ className: classes }}>
        <InsertImage thumb={thumb} />
        {link_text}
      </AnchorLink>
    );
  } else {
    return (
      <a
        href={url != null ? url : "#"}
        target={new_window != false ? "_blank" : "_self"}
        rel="noreferrer noopener"
        className={classes}
      >
        <InsertImage thumb={thumb} />
        {link_text}
      </a>
    );
  }
};

const InsertImage = ({ thumb }: { thumb: IMedia }) => {
  if (thumb != null) {
    return (
      <div className="link-image">
        <MediaImg media={thumb} loading="eager" />
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default CmsLink;
